export class User {
  id: string;
  name: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  folderName: string;
  active: boolean;
  companyId: string;
  type: string;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  updatedBy: string;

  private spanishNames?: Record<string, string> = {
    id: "identificador",
    name: "nombre",
    firstName: "Primer nombre",
    lastName: "Apellido",
    email: "correo electrónico",
    role: "rol",
    folderName: "nombre de carpeta",
    companyId: "ID de la empresa",
    type: "tipo",
    active: "activo",
    createdAt: "creado en",
    updatedAt: "actualizado en",
    createdBy: "creado por",
    updatedBy: "actualizado por",
  };

  constructor(data?: Partial<User>) {
    this.id = data?.id ?? "";

    this.name = data?.name ?? "";
    this.firstName = data?.firstName ?? "";
    this.lastName = data?.lastName ?? "";
    this.email = data?.email ?? "";
    this.role = data?.role ?? "";
    this.folderName = data?.folderName ?? "";
    this.companyId = data?.companyId ?? "";
    this.type = data?.type ?? "";

    this.active = data?.active ?? false;
    this.createdAt = data?.createdAt ? new Date(data.createdAt) : new Date();
    this.updatedAt = data?.updatedAt ? new Date(data.updatedAt) : new Date();
    this.createdBy = data?.createdBy ?? "";
    this.updatedBy = data?.updatedBy ?? "";
  }

  getSpanishName(propertyName: string): string {
    if (this.spanishNames && this.spanishNames[propertyName]) {
      return this.spanishNames[propertyName];
    }
    return propertyName;
  }
  toPlainObject(): Record<string, any> {
    return {
      id: this.id,
      name: this.name,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      role: this.role,
      folderName: this.folderName,
      type: this.type,
      companyId: this.companyId,
      active: this.active,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      createdBy: this.createdBy,
      updatedBy: this.updatedBy,
    };
  }
}
